import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { ChevronRight, FileText } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';

const PEACE_ESSAY_FANCYBOX_GROUP = 'peace-essay-poster';
const PEACE_ESSAY_IMAGE_SRC = '/assets/images/yarisma.jpeg';
const PEACE_ESSAY_PDF_FILENAME =
    'Istanbul RC Peace Essay Guidelines 2026-27.pdf';
const PEACE_ESSAY_PDF_HREF = `/assets/files/${encodeURIComponent(PEACE_ESSAY_PDF_FILENAME)}`;

/**
 * 3rd Essay Competition on International Peace — statik içerik sayfası.
 * URL: /3rd-essay-competition-on-international-peace
 */
export function PeaceEssayCompetitionPage() {
    const { t } = useTranslation();

    useEffect(() => {
        const escapedGroup = CSS.escape(PEACE_ESSAY_FANCYBOX_GROUP);
        const selector = `[data-fancybox="${escapedGroup}"]`;

        Fancybox.bind(selector, {
            Carousel: {
                infinite: false,
            },
            compact: false,
            placeFocusBack: true,
        });

        return () => {
            Fancybox.close();
            Fancybox.unbind(selector);
        };
    }, []);

    return (
        <>
            <PageSeo
                title={`${t('peaceEssayCompetition.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.peaceEssayCompetition')}
            />
            <SubpageLayout
                title={t('peaceEssayCompetition.title')}
                subtitle={t('peaceEssayCompetition.subtitle')}
                contentClassName="peace-essay-page"
            >
                <figure className="peace-essay-figure mb-4 mb-lg-5">
                    <a
                        href={PEACE_ESSAY_IMAGE_SRC}
                        className="peace-essay-hero-link"
                        data-fancybox={PEACE_ESSAY_FANCYBOX_GROUP}
                        data-caption={t('peaceEssayCompetition.imageAlt')}
                        aria-label={t('peaceEssayCompetition.imageEnlargeAria')}
                    >
                        <img
                            src={PEACE_ESSAY_IMAGE_SRC}
                            alt={t('peaceEssayCompetition.imageAlt')}
                            className="peace-essay-hero-img"
                            loading="lazy"
                            decoding="async"
                        />
                    </a>
                </figure>
                <div className="peace-essay-download mx-auto">
                    <a
                        href={PEACE_ESSAY_PDF_HREF}
                        download={PEACE_ESSAY_PDF_FILENAME}
                        className="peace-essay-download-card d-flex align-items-center gap-3 text-decoration-none"
                    >
                        <span
                            className="peace-essay-download-card-icon d-inline-flex align-items-center justify-content-center flex-shrink-0"
                            aria-hidden
                        >
                            <FileText
                                size={22}
                                strokeWidth={1.75}
                                className="peace-essay-download-card-icon-svg"
                            />
                        </span>
                        <span className="peace-essay-download-card-copy flex-grow-1 min-w-0 text-start">
                            <span className="peace-essay-download-card-title d-block">
                                {t('peaceEssayCompetition.guidelinesHeading')}
                            </span>
                            <span className="peace-essay-download-card-action d-block">
                                {t('peaceEssayCompetition.downloadButton')}
                            </span>
                        </span>
                        <ChevronRight
                            size={20}
                            strokeWidth={2}
                            className="peace-essay-download-card-chevron flex-shrink-0"
                            aria-hidden
                        />
                    </a>
                </div>
            </SubpageLayout>
        </>
    );
}
